import React, { memo } from "react";
import { Controller } from "react-hook-form";
import Select from 'react-select';
import RequiredTitle from "./RequiredTitle";

const MultiSelectField = ({ input, control, error }) => {
  const { name, type, label, validation, options = [], alignment = {}, defaultValues, ...rest } = input;
  const { sm = 12, md = 12, lg = 12 } = alignment;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: '3.5rem',
      minHeight: '3.5rem',
      borderColor: state.isFocused || state.isHover ? '#fcc2be' : '#d3d3d3',
      width: '100%',
      padding: '0.375rem 0.75rem',
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.5',
      color: '#6e6e6e',
      backgroundColor: '#fff',
      backgroundClip: 'padding-box',
      border: '1px solid #d3d3d3',
      appearance: 'none',
      borderRadius: '0.75rem',
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      color: '#6e6e6e',
      backgroundColor: state.isSelected || state.isFocused ? '#fcc2be' : '#fff',
      padding: '8px 12px',
      fontSize: '0.875rem', // Match font size of select
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#6e6e6e',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#6e6e6e',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: '#6c757d',
    }),
  };

  return (
    <div
      key={name}
      className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}
    >
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <Controller
        name={name}
        control={control}
        rules={validation}
        defaultValue={defaultValues}
        render={({ field }) => (
          <div>
            <Select
              id={name}
              isMulti
              value={options?.filter((option) => field.value?.includes(option.value))}
              onChange={(selected) => {
                const selectedValue = selected.map((opt) => opt.value);
                  field.onChange(selectedValue);
              }}
              options={options}
              styles={customStyles}
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
        )}
      />
    </div>
  );
};

export default memo(MultiSelectField);
